import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBranchServiceStep = id => {
  return http.get(
    `${getBaseUrl()}/branch_service_step/${id}`
  );
};

export const getBranchServiceSteps = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/branch_service_step`
    );
  }
  return http.get(
    `${getBaseUrl()}/branch_service_step?${paginate}`
  );
};

export const updateBranchServiceStep = data => {

  return http.put(
    `${getBaseUrl()}/branch_service_step/${data.id}`,
    data
  );
};
export const submitBranchServiceStep = data => {

  return http.post(
    `${getBaseUrl()}/branch_service_step`,
    data
  );
};
